(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("inventoryDetails", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/inventory/inventoryDetailsView.html",
            controller: ["accountsResource", "orderItemInventoryResource", "authService", "tenantFeaturesResource", "calendarSettingsService", "messageService", "$localStorage", "$sessionStorage", "$timeout", "$scope", "$state", "$compile", "$translate", "$uibModal", "DTOptionsBuilder", InventoryDetailsCtrl],
            controllerAs: "vm"
        };
        function InventoryDetailsCtrl(accountsResource, orderItemInventoryResource, authService, tenantFeaturesResource, calendarSettingsService, messageService, $localStorage, $sessionStorage, $timeout, $scope, $state, $compile, $translate, $uibModal, DTOptionsBuilder) {
            var vm = this;
            vm.data = $state.params.data;
            vm.name = vm.data.name;
            vm.isAdmin = $state.current.data.isAdmin;
            vm.person = $state.params.personSeq;
            if (vm.isAdmin) {
                accountsResource.getName({ personSeq: vm.person }, function (data) {
                    vm.userFullName = data.value;
                });
            }
            vm.productId = vm.data.productId;
            vm.available = vm.data.quantity - vm.data.assigned;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtInstance = {};
            var unassign = $translate.instant("common.unassign");
            vm.datePickerList = {
                assignedDateFrom: false,
                assignedDateTo: false,
                redeemedDateFrom: false,
                redeemedDateTo: false
            };
            calendarSettingsService.calendarSetup($scope);
            vm.openToggle = calendarSettingsService.openToggle;
            vm.storefrontInventoryAssignToOrganization = tenantFeaturesResource.getStorefrontInventoryAssignToOrganizationForCurrentUser();
            if ($sessionStorage.inventoryFilters) {
                vm.filters = $sessionStorage.inventoryFilters;
                if ($sessionStorage.inventoryFilters.assignedDate.fromValue)
                    vm.filters.assignedDate.fromValue = new Date($sessionStorage.inventoryFilters.assignedDate.fromValue);
                if ($sessionStorage.inventoryFilters.assignedDate.toValue)
                    vm.filters.assignedDate.toValue = new Date($sessionStorage.inventoryFilters.assignedDate.toValue);
                if ($sessionStorage.inventoryFilters.redeemedDate.fromValue)
                    vm.filters.redeemedDate.fromValue = new Date($sessionStorage.inventoryFilters.redeemedDate.fromValue);
                if ($sessionStorage.inventoryFilters.redeemedDate.toValue)
                    vm.filters.redeemedDate.toValue = new Date($sessionStorage.inventoryFilters.redeemedDate.toValue);
            }
            else {
                vm.filters = {
                    pathName: { enabled: true, value: "" },
                    assignedToName: { enabled: true, value: "" },
                    assignedToEmail: { enabled: true, value: "" },
                    assignedDate: { enabled: false, fromValue: "", toValue: "" },
                    redeemedByName: { enabled: false, value: "" },
                    redeemedByEmail: { enabled: false, value: "" },
                    redeemedDate: { enabled: false, fromValue: "", toValue: "" }
                };
            }
            var tableReloading = false;
            var reloadTableTimeout;
            vm.reloadTable = function () {
                if (tableReloading) {
                    if (reloadTableTimeout)
                        $timeout.cancel(reloadTableTimeout);
                    reloadTableTimeout = $timeout(function () {
                        vm.reloadTable();
                    }, 200);
                }
                else {
                    tableReloading = true;
                    $timeout(function () {
                        $sessionStorage.inventoryFilters = vm.filters;
                        vm.dtInstance.reloadData(function () {
                            tableReloading = false;
                        });
                        //if you want logging
                        //vm.dtInstance.reloadData(function (json) {
                        //	tableReloading = false;
                        //	console.log(json);
                        //});
                    });
                }
            };
            vm.refreshFilter = function (value) {
                $sessionStorage.inventoryFilters = vm.filters;
                // reload only if filtered
                if (value.length > 0)
                    vm.dtInstance.reloadData();
            };
            vm.closeFilter = function (filter) {
                vm.filters[filter].enabled = false;
                if (vm.filters[filter].hasOwnProperty("value"))
                    vm.refreshFilter(vm.filters[filter].value);
                if (vm.filters[filter].hasOwnProperty("fromValue")) {
                    vm.refreshFilter(vm.filters[filter].fromValue + vm.filters[filter].toValue);
                }
            };
            var url = "api/orderItemInventory/details/" + vm.productId;
            if (vm.isAdmin)
                url = "api/accounts/" + vm.person + "/inventoryDetails/" + vm.productId;
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withOption("ajax", {
                url: url,
                error: function (error) {
                    if (error.status === 401) {
                        $state.go("main.signIn");
                    }
                    else if (error.status === 403) {
                        $state.go("main.accessDenied");
                    }
                },
                type: "POST",
                headers: {
                    Authorization: "Bearer " + authService.getToken(),
                    CurrentLocalizationId: $localStorage.currentLocalizationId
                },
                data: function (data) {
                    var search;
                    data.columns[1].search.value = vm.filters.assignedToName.enabled ? vm.filters.assignedToName.value : "";
                    data.columns[2].search.value = vm.filters.assignedToEmail.enabled ? vm.filters.assignedToEmail.value : "";
                    data.columns[3].search.value = "";
                    if (vm.filters.assignedDate.enabled) {
                        search = "";
                        if (vm.filters.assignedDate.fromValue)
                            search = moment(vm.filters.assignedDate.fromValue).utc().format("YYYY-MM-DD HH:mm");
                        search = search + "|";
                        if (vm.filters.assignedDate.toValue)
                            search = search + moment(vm.filters.assignedDate.toValue).utc().format("YYYY-MM-DD HH:mm");
                        data.columns[3].search.value = search !== "|" ? search : "";
                    }
                    data.columns[4].search.value = vm.filters.redeemedByName.enabled ? vm.filters.redeemedByName.value : "";
                    data.columns[5].search.value = vm.filters.redeemedByEmail.enabled ? vm.filters.redeemedByEmail.value : "";
                    data.columns[6].search.value = "";
                    if (vm.filters.redeemedDate.enabled) {
                        search = "";
                        if (vm.filters.redeemedDate.fromValue)
                            search = moment(vm.filters.redeemedDate.fromValue).utc().format("YYYY-MM-DD HH:mm");
                        search = search + "|";
                        if (vm.filters.redeemedDate.toValue)
                            search = search + moment(vm.filters.redeemedDate.toValue).utc().format("YYYY-MM-DD HH:mm");
                        data.columns[7].search.value = search !== "|" ? search : "";
                    }
                }
            })
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withDataProp("data")
                .withOption("processing", true)
                .withOption("serverSide", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                //.withOption("rowCallback", rowCallback)
                .withOption("createdRow", function (row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row))($scope);
            })
                .withPaginationType("full_numbers")
                .withOption("order", [1, "asc"])
                .withBootstrap();
            vm.dtColumns = [
                { "data": null, "defaultContent": "", "class": "control", "orderable": false, "targets": 0 },
                {
                    "data": "assignedToEmail",
                    "title": $translate.instant("common.lists.assignedToEmail")
                },
                {
                    "data": "assignedToName",
                    "title": $translate.instant("common.lists.assignedToName")
                },
                {
                    "data": "assignedDate",
                    "title": $translate.instant("common.lists.assignedDate"),
                    "class": "text-nowrap",
                    "render": function (data) {
                        return data ? moment.utc(data).local().format("MMM D, YYYY") : "";
                    }
                },
                {
                    "data": "redeemedByName",
                    "title": $translate.instant("common.lists.redeemedByName")
                },
                {
                    "data": "redeemedByEmail",
                    "title": $translate.instant("common.lists.redeemedByEmail")
                },
                {
                    "data": "redeemedDate",
                    "title": $translate.instant("common.lists.redeemedDate"),
                    "class": "text-nowrap",
                    "render": function (data) {
                        return data ? moment.utc(data).local().format("MMM D, YYYY") : "";
                    }
                },
                {
                    "responsivePriority": 1,
                    "data": null,
                    "title": $translate.instant("common.action"),
                    "visible": !vm.isAdmin,
                    "render": function (_data, _type, full) {
                        var buttons = "";
                        if (!full.redeemedDate)
                            buttons = "<button class='btn btn-sm btn-warning' stop-event='click' ng-click='vm.unassign($event, \"" + full.code + "\")'>" + unassign + "</button>";
                        return buttons;
                    },
                    "sortable": false
                }
            ];
            vm.assign = function () {
                vm.storefrontInventoryAssignToOrganization.$promise.then(function (result) {
                    $state.go("main.accountInventoryDetails.assign", { productId: vm.productId, assignToOrganization: result.value, available: vm.available });
                }).catch(angular.noop);
            };
            vm.transfer = function () {
                $state.go("main.accountInventoryDetails.transfer", { productId: vm.productId, available: vm.available });
            };
            vm.unassign = function (btn, code) {
                if (btn.target.disabled)
                    return;
                btn.target.disabled = true;
                var modal = $uibModal.open({
                    templateUrl: "unassignInventoryConfirmation.html",
                    backdrop: "static",
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    orderItemInventoryResource.unassign({ code: code }, function () {
                        vm.available += 1;
                        vm.reloadTable();
                        //$state.transitionTo($state.current, $state.params, {
                        //	reload: true, inherit: false, notify: true
                        //});
                    }, function (error) {
                        messageService.error(error);
                    });
                }, function () {
                    //escape or no pressed
                    btn.currentTarget.disabled = false;
                });
            };
        }
    });
}());
